// extracted by mini-css-extract-plugin
module.exports = {"container":"DangerouslySetInnerHTML_container__flFWh","onlyText":"DangerouslySetInnerHTML_onlyText__9aQPU"};